import React from 'react';

const BarLoader = ({ loadingText }: { loadingText?: string }) => {
   return (
      <div className="bar-loader-container">
         <div className="bar-loader"></div>
         <p className="bar-loading-text">{loadingText}</p>
      </div>
   );
};

export default BarLoader;
